import React from 'react';
import '../../styles/RateCard.css';

const SpecsBeAdsMobile = () => {
    return (
        <section className="specs-be-ads-section py-5">
            <div className="container">
                <div className='m-0 row justify-content-between align-items-center mb-4'>
                    <div className='col-lg-3 col-md-4 p-0'>
                        <h2 className="title text-white text-capitalize mb-4" data-aos="fade-right" data-aos-delay="200">
                            SPECS<br /><span className="highlight-bg">Be Ads</span>
                        </h2>
                    </div>
                    <div className='col-lg-3 col-md-4 p-3 rounded' data-aos="fade-left" data-aos-delay="200">
                        <h3>Ubicaciones:</h3>
                        <p>Los banners se pueden mostrar en Home, Interiores de preferencia o rotar en todo el sitio (ROS).</p>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-md-9 mt-3' data-aos="fade-right" data-aos-delay="200">
                        <div className="table-responsive">
                            <table className="table table-bordered text-center align-middle custom-table">
                                <thead>
                                    <tr>
                                        <th className='pt-4 pb-4'>Formato</th>
                                        <th className='pt-4 pb-4'>Dimensiones</th>
                                        <th className='pt-4 pb-4'>Admite</th>
                                        <th className='pt-4 pb-4'>Notas</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>FullScreen Banner Mobile</td>
                                        <td>320x480</td>
                                        <td rowSpan="10">
                                            Imagen: JPG, PNG o GIF.<br />
                                            <br />
                                            Animado: HTML comprimido en carpeta ZIP.<br />
                                            <br />
                                            Tags de 3ros.
                                        </td>
                                        <td rowSpan="10">Los materiales sin compresión deben tener un peso inferior a 1 mb.</td>
                                    </tr>
                                    <tr>
                                        <td>Square Box</td>
                                        <td>300x250</td>
                                    </tr>
                                    <tr>
                                        <td>Big Leaderboard Mobile</td>
                                        <td>320x100</td>
                                    </tr>
                                    <tr>
                                        <td>Header Leaderboard Mobile</td>
                                        <td>320x50</td>
                                    </tr>
                                    <tr>
                                        <td>Leaderboard Mobile</td>
                                        <td>320x50</td>
                                    </tr>
                                    <tr>
                                        <td>Footer Leaderboard Mobile</td>
                                        <td>320x50</td>
                                    </tr>
                                    <tr>
                                        <td>Skyscraper</td>
                                        <td>160x600</td>
                                    </tr>
                                    <tr>
                                        <td>Small Skyscraper</td>
                                        <td>120x600</td>
                                    </tr>
                                    <tr>
                                        <td>Billboard</td>
                                        <td>970x250</td>
                                    </tr>
                                    <tr>
                                        <td>Sponsor Take Cover Mobile (FullScreen Banner M + Footer Leaderboard M)</td>
                                        <td>320x480 + 320x50</td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>
                    <div className='col-md-3 mt-3' data-aos="fade-left" data-aos-delay="200">
                        <div className='d-flex justify-content-center'>
                            <div className='position-relative z-0' style={{ width: '100%' }}>
                                <h3 className="subtitle-rate-card fw-bold text-center w-100 text-white py-2 rounded-top">
                                    Mobile
                                </h3>

                                <div className='position-absolute top-100 start-50 translate-middle'>
                                    <svg width="2em" height="2em" viewBox="0 0 16 16" className="bi bi-caret-down-fill" fill="#439b6b" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                    </svg>
                                </div>
                            </div>
                        </div>

                        <div className='mt-3 rounded pt-5 pb-5 text-center'>
                            <img src="assets/mobile.png" className='img-fluid w-75' alt="" />
                        </div> 
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SpecsBeAdsMobile;